<template>
  <div>
    <label class="form-label">{{ label }}</label>
    <select v-model="selectedPermissions" multiple>
      <option
        v-for="(permission, index) in permissions"
        :value="permission.name"
        :key="index"
      >
        {{ permission.name }}
      </option>
    </select>
  </div>
</template>

<script lang="babel">
export default {
  created() {
    this.$store.dispatch("permissions/read");
  },
  props: {
    value: null,
    label: null,
    id: {
      required: false,
      default: 'Berechtigungen'
    },
    attributes: null,
    name: {
      required: false,
      default: 'permission'
    }
  },
  computed: {
    permissions() {
      return this.$store.getters["permissions/all"];
    },
    selectedPermissions: {
      get() {
        return this.value || [];
      },
      set(newVal) {
        this.$emit('filter-change', {
          id: this.id,
          name: this.name,
          attributes: this.attributes,
          value: newVal
        });
      }
    }
  }
};
</script>
